import { render } from "./EditImgTubeFormComponent.vue?vue&type=template&id=29320cdb&scoped=true"
import script from "./EditImgTubeFormComponent.vue?vue&type=script&lang=js"
export * from "./EditImgTubeFormComponent.vue?vue&type=script&lang=js"

import "./EditImgTubeFormComponent.vue?vue&type=style&index=0&id=29320cdb&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29320cdb"]])

export default __exports__